import { ToastSeverity } from "src/Shared/Components/Toast/Enum";

const toastService = {
    openToast: (isOpen=true,serverity=ToastSeverity.Error,message="") => {
      const event = new CustomEvent('openToast', { detail: { message, isOpen } });
      window.dispatchEvent(event);
    },
  };
  
  export default toastService;
  